import Object from "./Object.svelte"
import ObjectArray from "./ObjectArray.svelte"
import ImageSelect from "./ImageSelect.svelte"
import Number from "./Number.svelte"
import Step from "./Step.svelte"
import Radio from "./Radio.svelte"
import InfoText from "./InfoText.svelte"
import Image from "./Image.svelte"
import Textarea from "./Textarea.svelte"
import MailboxQuantity from "./MailboxQuantity.svelte"

export default {
    default: Object,
    infoText: InfoText,
    image: Image,
    step: Step,
    imageSelect: ImageSelect,
    number: Number,
    textarea: Textarea,
    radio: Radio,
    object: Object,
    "object[]": ObjectArray,
    mailboxQuantity: MailboxQuantity,
}
